import { render, staticRenderFns } from "./companyworkweeks.vue?vue&type=template&id=b1b815c8&"
import script from "./companyworkweeks.vue?vue&type=script&lang=js&"
export * from "./companyworkweeks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports